<template>
  <div>
    <h3 class="title">今日数据</h3>
    <div class="card-wrapper">
      <div class="card">
        <header>
          <label>销售金额(元)</label>
          <a-tooltip>
            <template slot="title">
              统计周期内，成功支付的累计订单金额
            </template>
            <img src="@/assets/images/icon-question.png"/>
          </a-tooltip>
        </header>
        <a-statistic :value="statisticData.saleAmount" class="today-num"/>
        <a-statistic :value="statisticData.saleAmountComp" class="comp-num" prefix="昨日:"/>
        <a-statistic 
          :value="Math.abs(statisticData.saleAmountHb) || 0" 
          :class="+statisticData.saleAmountHb < 0 ? 'ratio down' : +statisticData.saleAmountHb > 0 ? 'ratio up' : 'ratio'" 
          suffix="%">
          <template #prefix>
            环比: 
            <img v-if="+statisticData.saleAmountHb < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
            <img v-if="+statisticData.saleAmountHb > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
          </template>
        </a-statistic>
      </div>

      <div class="card">
        <header>
          <label>消费会员数</label>
          <a-tooltip>
            <template slot="title">
              统计周期内，成功支付的用户数量。统计时间段内，同一用户产生多笔订单会去重计算
            </template>
            <img src="@/assets/images/icon-question.png"/>
          </a-tooltip>
        </header>
        <a-statistic :value="statisticData.payMember" class="today-num"/>
        <a-statistic :value="statisticData.payMemberComp" class="comp-num" prefix="昨日:"/>
        <a-statistic 
          :value="Math.abs(statisticData.payMemberHb) || 0" 
          :class="+statisticData.payMemberHb < 0 ? 'ratio down' : +statisticData.payMemberHb > 0 ? 'ratio up' : 'ratio'" 
          suffix="%">
          <template #prefix>
            环比: 
            <img v-if="+statisticData.payMemberHb < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
            <img v-if="+statisticData.payMemberHb > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
          </template>
        </a-statistic>
      </div>

      <div class="card">
        <header>
          <label>客单价(元)</label>
          <a-tooltip>
            <template slot="title">
              统计周期内，平均每笔订单的支付金额
            </template>
            <img src="@/assets/images/icon-question.png"/>
          </a-tooltip>
        </header>
        <a-statistic :value="statisticData.perCustAmount" class="today-num"/>
        <a-statistic :value="statisticData.perCustAmountComp" class="comp-num" prefix="昨日:"/>
        <a-statistic 
          :value="Math.abs(statisticData.perCustAmountHb) || 0" 
          :class="+statisticData.perCustAmountHb < 0 ? 'ratio down' : +statisticData.perCustAmountHb > 0 ? 'ratio up' : 'ratio'" 
          suffix="%">
          <template #prefix>
            环比: 
            <img v-if="+statisticData.perCustAmountHb < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
            <img v-if="+statisticData.perCustAmountHb > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
          </template>
        </a-statistic>
      </div>

      <div class="card">
        <header>
          <label>订单数量</label>
          <a-tooltip>
            <template slot="title">
              统计周期内，用户下单的累计订单数量
            </template>
            <img src="@/assets/images/icon-question.png"/>
          </a-tooltip>
        </header>
        <a-statistic :value="statisticData.orderCount" class="today-num"/>
        <a-statistic :value="statisticData.orderCountComp" class="comp-num" prefix="昨日:"/>
        <a-statistic 
          :value="Math.abs(statisticData.orderCountHb) || 0" 
          :class="+statisticData.orderCountHb < 0 ? 'ratio down' : +statisticData.orderCountHb > 0 ? 'ratio up' : 'ratio'" 
          suffix="%">
          <template #prefix>
            环比: 
            <img v-if="+statisticData.orderCountHb < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
            <img v-if="+statisticData.orderCountHb > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
          </template>
        </a-statistic>
      </div>

      <div class="card">
        <header>
          <label>商品数量</label>
          <a-tooltip>
            <template slot="title">
              统计周期内，用户下单的累计商品件数
            </template>
            <img src="@/assets/images/icon-question.png"/>
          </a-tooltip>
        </header>
        <a-statistic :value="statisticData.skuCount" class="today-num"/>
        <a-statistic :value="statisticData.skuCountComp" class="comp-num" prefix="昨日:"/>
        <a-statistic 
          :value="Math.abs(statisticData.skuCountHb) || 0" 
          :class="+statisticData.skuCountHb < 0 ? 'ratio down' : +statisticData.skuCountHb > 0 ? 'ratio up' : 'ratio'" 
          suffix="%">
          <template #prefix>
            环比: 
            <img v-if="+statisticData.skuCountHb < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
            <img v-if="+statisticData.skuCountHb > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
          </template>
        </a-statistic>
      </div>

      <div class="card">
        <header>
          <label>退款金额(元)</label>
          <a-tooltip>
            <template slot="title">
              统计周期内，退款的累计订单金额
            </template>
            <img src="@/assets/images/icon-question.png"/>
          </a-tooltip>
        </header>
        <a-statistic :value="statisticData.refundAmount" class="today-num"/>
        <a-statistic :value="statisticData.refundAmountComp" class="comp-num" prefix="昨日:"/>
        <a-statistic 
          :value="Math.abs(statisticData.refundAmountHb) || 0" 
          :class="+statisticData.refundAmountHb < 0 ? 'ratio down' : +statisticData.refundAmountHb > 0 ? 'ratio up' : 'ratio'" 
          suffix="%">
          <template #prefix>
            环比: 
            <img v-if="+statisticData.refundAmountHb < 0" src="@assets/images/icon-down.png" style="width: 12px; height: 12px;" />
            <img v-if="+statisticData.refundAmountHb > 0" src="@assets/images/icon-up.png" style="width: 12px; height: 12px;" />
          </template>
        </a-statistic>
      </div>
    </div>
  </div>
</template>
<script>
  import { Statistic, Tooltip } from "ant-design-vue"

  export default {
    name: 'today-data',
    components: {
      [Statistic.name]: Statistic,
      [Tooltip.name]: Tooltip
    },
    data() {
      return {
        statisticData: {}
      }
    },
    async created() {
      const res = await this.$store.dispatch('partnerHome/queryHomeCoreData')
      if (res && +res.code === 0) {
        this.statisticData = res.data
      }
    },
  }
</script>
<style scoped lang="scss">
  h3.title {
    font-size: 14px;
    font-family: MicrosoftYaHei, PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 18px;
    margin-bottom: 15px;
  }
  .card-wrapper {
    display: flex;
    .card {
      flex: 1;
      min-width: 160px;
      max-width: 240px;
      height: 122px;
      border-radius: 2px;
      border: 1px solid #F6F6F6;
      margin-right: 18px;
      padding: 14px 18px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      header {
        display: flex;
        align-items: center;
        label {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 16px;
        }
        img {
          width: 14px;
          height: 14px;
          margin-left: 6px;
        }
      }
      .today-num {
        /deep/.ant-statistic-content {
          font-weight: 600;
          color: #1C7AE5;
          line-height: 20px;
          font-size: 16px;
        }
      }
      .comp-num {
        /deep/.ant-statistic-content {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
        }
        /deep/.ant-statistic-content-value-decimal {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
        }
      }
      .ratio {
        /deep/.ant-statistic-content {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
        }
        /deep/.ant-statistic-content-value-decimal {
          font-size: 12px;
        }
        
        /deep/.ant-statistic-content-suffix {
          font-size: 12px;
          margin-left: 0;
        }
        /deep/.ant-statistic-content-prefix {
          margin-right: 0;
        }
      }
      .up {
        /deep/.ant-statistic-content-value-int {
          color: #FF184F;
        }
        /deep/.ant-statistic-content-value-decimal {
          color: #FF184F;
        }
        /deep/.ant-statistic-content-suffix {
          color: #FF184F;
        }
      } 
      .down {
        /deep/.ant-statistic-content-value-int {
          color: #1ECA6E;
        }
        /deep/.ant-statistic-content-value-decimal {
          color: #1ECA6E;
        }
        /deep/.ant-statistic-content-suffix {
          color: #1ECA6E;
        }
      } 
    }
  }
  
</style>
